const Header = ({ className,  tenantlogo, metadata, prospectLogoUrl }) => {
    return (
        <header className={`${className} border-b border-gray-200 sticky top-0 z-50`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
            <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                    {tenantlogo && (
                        <img 
                            src={tenantlogo} 
                            alt={metadata.my_company_name || 'Company Logo'} 
                            className="h-12 w-auto"
                            crossOrigin="anonymous"
                        />
                    )}
                    <div>
                        <h1 className="text-xl font-bold text-gray-900">
                            {metadata.my_company_name || 'Company'}
                        </h1>
                   
                    </div>
                </div>
                <div className="flex items-center space-x-4">
                    {prospectLogoUrl && (
                        <img 
                            src={prospectLogoUrl}
                            alt={`${metadata.prospect_company_name || 'Prospect'} Logo`}
                            className="h-12 w-auto"
                            crossOrigin="anonymous"
                            onError={(e) => {
                                e.target.style.display = 'none';
                            }}
                        />
                    )}
                    <div className="text-right">
                        <h2 className="text-lg font-semibold text-gray-900">
                            {metadata.prospect_company_name || 'Prospect Company'}
                        </h2>
                     
                    </div>
                </div>
            </div>
        </div>
    </header>
    )
}

export default Header;